export enum ProfanityFilterEnum {
  Disabled,
  Flag,
  Block
}
